import { View, Text } from "react-native";
import React from "react";
import MyText from "../../custom/MyText";
import {
  chatMeSenderBackground,
  chatNotMeSenderBackground,
} from "../../../colors";
import MessageStatus from "./MessageStatus";

export default function TextMessage(props) {
  const { meSender, value, status, sender } = props;
  return (
    <View
      style={{
        alignItems: meSender ? "flex-start" : "flex-end",
        marginVertical: 10,
      }}
    >
      <View
        style={{
          width: "65%",
          minHeight: 50,
          borderWidth: 1,
          borderRadius: 10,
          borderTopRightRadius: meSender ? 10 : 0,
          borderTopLeftRadius: meSender ? 0 : 10,
          marginVertical: 5,
          marginHorizontal: 10,
          paddingHorizontal: 10,
          paddingVertical: 5,
          flexDirection: meSender ? "row" : "row-reverse",
          alignItems: "center",
          overflow: "hidden",
          borderColor: "#ddd",
          backgroundColor: props.meSender
            ? chatMeSenderBackground
            : chatNotMeSenderBackground,
        }}
      >
        <MyText>{value}</MyText>
      </View>
      <View
        style={{
          flexDirection: meSender ? "row" : "row-reverse",
          width: "65%",
        }}
      >
        <View style={{ flex: 1 }}></View>
        <MessageStatus meSender={sender === "doctor"} status={status} />
      </View>
    </View>
  );
}
